import api from './api';

export interface RepairService {
  id: number;
  title: string;
  model: string;
  price?: number;
  description?: string;
  duration?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRepairServiceDto {
  title: string;
  model: string;
  price?: number;
  description?: string;
  duration?: number;
  isActive?: boolean;
}

class RepairServiceService {
  async getAll(): Promise<RepairService[]> {
    const { data } = await api.get('/repair-services');
    return data;
  }

  async getActive(): Promise<RepairService[]> {
    const { data } = await api.get('/repair-services/active');
    return data;
  }

  async getById(id: number): Promise<RepairService> {
    const { data } = await api.get(`/repair-services/${id}`);
    return data;
  }

  async create(dto: CreateRepairServiceDto): Promise<RepairService> {
    const { data } = await api.post('/repair-services', dto);
    return data;
  }

  async update(id: number, dto: Partial<CreateRepairServiceDto>): Promise<RepairService> {
    const { data } = await api.put(`/repair-services/${id}`, dto);
    return data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/repair-services/${id}`);
  }

  async toggleActive(id: number): Promise<RepairService> {
    const { data } = await api.patch(`/repair-services/${id}/toggle`, {});
    return data;
  }
}

export const repairServiceService = new RepairServiceService();
